import { nameSpace } from './nameSpace';
import { createSliceWithName as filterSlice } from 'modules/filters/reducer';
import { createSelectors } from 'modules/filters/selectors';

export const moduleName = 'filters';
export const selectState = state => state[nameSpace][moduleName];
export const EVENT_TYPE_DEFAULT_FILTERS = {
  includeArchived: false,
  category: undefined,
};
const initialState = {
  filterKey: false,
  filterValues: EVENT_TYPE_DEFAULT_FILTERS,
};
const filters = filterSlice(`${nameSpace}/${moduleName}`, initialState);

export const { reducer } = filters;
export const { actions } = filters;
export const selectors = createSelectors(selectState);
